module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/active-tool/carussel/carussel.component.scss
// module id = ./src/app/StartApp/welcome/start/simulator/panel-wrapper/mem/active-tool/carussel/carussel.component.scss
// module chunks = main